import { FC, Fragment, memo } from 'react'
import { Button, IconButton, Text } from '@chakra-ui/react'
import { formatNumberWithPunctuation } from 'utils/transforms/number'
import { SimpleLeftArrow, SimpleRightArrow } from 'components/icons'

export type PaginationItem = {
  label: number
  value: number
}

type Props = {
  currentPage: number
  choosePages: PaginationItem[]
  onChangePage: (newPage: number) => void
}

const PageItems: FC<Props> = ({ currentPage, choosePages, onChangePage }) => {
  if (!choosePages.length) return null

  const lastPage = choosePages[choosePages.length - 1].value

  return (
    <Fragment>
      {/* Página anterior */}
      <IconButton
        onClick={() => onChangePage(currentPage - 1)}
        isDisabled={currentPage === 1}
        icon={<SimpleLeftArrow />}
        aria-label="Próxima página"
        variant={'ghost'}
      />

      {choosePages.map(({ label, value }, index) => {
        const previousValue = choosePages[index - 1]?.value
        const hasGap = previousValue && value - previousValue > 1
        const isCurrentPage = value === currentPage

        return (
          <Fragment key={value}>
            {hasGap && <Text px={2}>...</Text>}

            <Button
              minWidth="min-content"
              onClick={() => onChangePage(value)}
              color={isCurrentPage ? 'light' : 'primary'}
              bg={isCurrentPage ? 'primary' : 'light'}
              borderWidth="1px"
              borderColor="primary"
              _hover={{ color: 'light', bg: 'primary' }}
            >
              {isNaN(label) ? label : formatNumberWithPunctuation(label)}
            </Button>
          </Fragment>
        )
      })}

      {/* Próxima página */}
      <IconButton
        onClick={() => onChangePage(currentPage + 1)}
        isDisabled={currentPage === lastPage}
        icon={<SimpleRightArrow />}
        aria-label="Próxima página"
        variant={'ghost'}
      />
    </Fragment>
  )
}

export default memo(PageItems)
